import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import BortalLogo from "./BortalLogo";
const Footer = () => {
  return <footer className="bg-muted/30 border-t border-border py-6">
      <div className="container mx-auto px-6 flex flex-col items-center justify-center gap-3">
        <BortalLogo className="h-8" aria-label="Bortal logo" />
        <p className="text-xs text-muted-foreground/80 text-center">
          Built in Bavaria — serving artists worldwide.
        </p>
        <a 
          href="https://instagram.com/bortal.music" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Follow Bortal on Instagram"
        >
          <Instagram className="h-5 w-5" />
        </a>
        <div className="flex items-center gap-4 flex-wrap justify-center">
          <Link to="/privacy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            Privacy
          </Link>
          <span className="text-xs text-muted-foreground/50">•</span>
          <Link to="/terms" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            Terms
          </Link>
          <span className="text-xs text-muted-foreground/50">•</span>
          <Link to="/about" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            About
          </Link>
          <span className="text-xs text-muted-foreground/50">•</span>
          <Link to="/donate" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            Donate
          </Link>
        </div>
        <p className="text-muted-foreground text-xs">
          © {new Date().getFullYear()} Qwynn. All rights reserved.
        </p>
      </div>
    </footer>;
};
export default Footer;